import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import "./Cart.css";

const Cart = () => {
  const {
    cart,
    removeFromCart,
    increaseQty,
    decreaseQty,
  } = useContext(CartContext);

  const navigate = useNavigate();

  const total = cart.reduce(
    (sum, item) => sum + item.price * (item.qty || 1),
    0
  );

  return (
    <div className="cart-container">

      {/* EMPTY STATE */}
      {cart.length === 0 ? (
        <div className="empty-cart">
          <div className="empty-icon">🛒</div>
          <h2>Your Cart</h2>
          <p>Your cart is empty 😢</p>

          <button
            className="explore-btn"
            onClick={() => navigate("/")} 
          >
            Explore Collection →
          </button>
        </div>
      ) : (
        <>
          {/* LEFT */}
          <div className="cart-left">
            <h2>Your Cart</h2>

            {cart.map((item) => (
              <div key={item.id} className="cart-row">

                {/* IMAGE */}
                <img
                  src={item.image || item.images?.[0]}
                  alt={item.name}
                />

                {/* DETAILS */}
                <div className="cart-info">
                  <h3>{item.name}</h3>
                  <p className="price">₹{item.price}</p>

                  {/* QTY */}
                  <div className="qty">
                    <button onClick={() => decreaseQty(item.id)}>-</button>
                    <span>{item.qty}</span>
                    <button onClick={() => increaseQty(item.id)}>+</button>
                  </div>

                  {/* REMOVE */}
                  <span
                    className="remove"
                    onClick={() => removeFromCart(item.id)}
                  >
                    Remove
                  </span>
                </div>

                {/* SUBTOTAL */}
                <div className="subtotal">
                  ₹{item.price * item.qty}
                </div>

              </div>
            ))}
          </div>

          {/* RIGHT */}
          <div className="cart-right">
            <h3>Subtotal ({cart.length} items)</h3>
            <h2>₹{total}</h2>

            <button className="checkout">
              Proceed to Buy
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;